// Stripe card error codes name the card part, e.g. incomplete_number or invalid_expiry_year_past.
const CARD_PARTS = [
  ['number', 'card_number'],
  ['expiry', 'card_expiry'],
  ['cvc', 'card_cvc'],
  ['zip', 'card_zip'],
];

/**
 * checkout_field_error params for an incomplete card, from the last CardElement change event.
 * Stripe reports a code only after the user leaves an invalid part. An untouched card fails
 * as incomplete_number when submitted, a partly filled one without a code as incomplete.
 */
export function cardFieldError(change) {
  const code =
    change?.error?.code ?? (change && !change.empty ? 'incomplete' : 'incomplete_number');
  const part = CARD_PARTS.find(([key]) => code.includes(key));
  return { field: part?.[1] ?? 'card', type: code };
}
